export { default as LoyaltyNoRewardPoints } from './loyalty-no-reward-points';
